import { PROVINCE_NAMES } from "../../lib/tone";

const Bar = ({ data, color = "#2E7D32", limit = 10, testId, names = {}, cap }) => {
  const rows = Object.entries(data).slice(0, limit);
  const max = Math.max(1, ...rows.map(([, v]) => v));
  return (
    <ul className="space-y-2" data-testid={testId}>
      {rows.map(([k, v]) => (
        <li key={k} className="text-sm">
          <div className="flex justify-between gap-2"><span className={`truncate text-slate-700 ${cap ? "capitalize" : ""}`}>{names[k] || k}</span><span className="font-semibold text-slate-900">{v}</span></div>
          <div className="mt-1 h-2 rounded-full bg-slate-100"><div className="h-2 rounded-full" style={{ width: `${(100 * v) / max}%`, background: color }} /></div>
        </li>
      ))}
    </ul>
  );
};
const Card = ({ title, children }) => <div className="rounded-3xl border border-slate-200 bg-white p-6"><h3 className="mb-4 text-lg font-semibold text-slate-900">{title}</h3>{children}</div>;

export const VolunteerDashboard = ({ a }) => !a ? <div className="h-64 animate-pulse rounded-3xl bg-white" /> : (
  <div className="space-y-6" data-testid="volunteer-dashboard">
    <div><h2 className="text-2xl font-bold tracking-tight text-slate-900">Action Index™</h2><p className="mt-1 text-sm text-slate-700">Open volunteer opportunities by cause, region and organization — a snapshot of where help is needed right now.</p></div>
    <div className="grid gap-6 lg:grid-cols-3">
      <Card title="Opportunities by cause"><Bar data={a.by_category} testId="dash-by-category" limit={13} /></Card>
      <Card title="Top regions"><Bar data={a.by_region} color="#1E3A8A" testId="dash-by-region" /></Card>
      <Card title="Who's asking for help"><Bar data={a.by_org_type} color="#0F766E" testId="dash-by-org-type" /></Card>
    </div>
    <div className="grid gap-6 lg:grid-cols-3">
      <Card title="By province"><Bar data={a.by_province} color="#1E3A8A" limit={13} names={PROVINCE_NAMES} /></Card>
      <Card title="Good fit for"><Bar data={a.by_tag} color="#22C55E" cap /></Card>
      <Card title="Commitment"><Bar data={a.by_commitment} color="#D97706" cap />
        <p className="mt-4 text-xs text-slate-500">Counts reflect live listings only — expired and past opportunities are removed automatically.</p></Card>
    </div>
  </div>
);
